/* KÒRMESIC collection filters: apply instantly by re-rendering the section (Section Rendering API), no page reload. */
(function () {
  'use strict';
  function init() {
    var form = document.querySelector('[data-plp-form]'); if (!form) return;
    var sid = form.dataset.section, base = form.dataset.url, timer, ctrl;
    var results = form.querySelector('[data-plp-results]');

    function query() {
      var p = new URLSearchParams();
      [].forEach.call(form.elements, function (el) {
        if (!el.name || el.disabled) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.value === '') return;
        p.append(el.name, el.value);
      });
      // a price range that spans everything is not a filter
      var pr = form.querySelector('[data-fx-price]');
      if (pr) {
        var lo = pr.querySelector('[data-fx-lo-in]'), hi = pr.querySelector('[data-fx-hi-in]');
        if (lo && +lo.value === 0) p.delete(lo.name);
        if (hi && +hi.value >= +hi.max) p.delete(hi.name);
      }
      return p.toString();
    }
    function load(url) {
      clearTimeout(timer);
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      var open = {};
      form.querySelectorAll('.fx-g').forEach(function (d) { open[d.dataset.fx] = d.open; });
      results.classList.add('is-loading');
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sid, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          form.querySelectorAll('[data-plp-part]').forEach(function (el) {
            var n = doc.querySelector('[data-plp-part="' + el.dataset.plpPart + '"]'); if (!n) return;
            el.innerHTML = n.innerHTML; el.hidden = n.hidden;
          });
          form.querySelectorAll('.fx-g').forEach(function (d) { if (d.dataset.fx in open) d.open = open[d.dataset.fx]; });
          var sel = doc.querySelector('select[name=sort_by]'), mine = form.querySelector('select[name=sort_by]');
          if (sel && mine) mine.value = sel.value;
          initPrice();
          results.classList.remove('is-loading');
          if (history.replaceState) history.replaceState(null, '', url);
          if (window.KM && KM.paintHearts) KM.paintHearts();
          if (window.innerWidth >= 1000) {
            var top = results.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-top')) || 0) - 80;
            if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function (e) { if (e.name !== 'AbortError') location.href = url; });
    }
    function apply(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () { var q = query(); load(base + (q ? '?' + q : '')); }, delay == null ? 200 : delay);
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-fx-lo],[data-fx-hi]')) return apply(150);
      if (t.matches('[data-fx-lo-in],[data-fx-hi-in]')) { syncFromInputs(); return apply(150); }
      apply();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(0); });
    form.addEventListener('click', function (e) {
      var a = e.target.closest('[data-fx-link],[data-fx-clear]');
      if (a) { e.preventDefault(); load(a.getAttribute('href')); return; }
      var m = e.target.closest('[data-fx-more]');
      if (m) { var l = m.previousElementSibling; l.classList.toggle('is-open'); m.textContent = l.classList.contains('is-open') ? 'Show less' : 'Show all ' + l.children.length; return; }
      var b = e.target.closest('[data-more-btn]'); if (!b) return;
      e.preventDefault(); b.textContent = 'Loading'; b.setAttribute('aria-disabled', 'true');
      fetch(b.href).then(function (r) { return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html'), grid = form.querySelector('[data-plp-grid]');
        d.querySelectorAll('[data-plp-grid] .pc').forEach(function (c, i) { c.classList.add('fade-up'); c.style.animationDelay = Math.min(i, 8) * 35 + 'ms'; grid.appendChild(c); });
        var nm = d.querySelector('[data-more]'), om = form.querySelector('[data-more]'); if (nm && om) om.replaceWith(nm);
        if (window.KM && KM.paintHearts) KM.paintHearts();
      });
    });

    /* dual price slider kept in sync with the two number boxes */
    function syncFromInputs() {
      var pr = form.querySelector('[data-fx-price]'); if (!pr) return;
      var lo = pr.querySelector('[data-fx-lo]'), hi = pr.querySelector('[data-fx-hi]');
      lo.value = pr.querySelector('[data-fx-lo-in]').value || 0; hi.value = pr.querySelector('[data-fx-hi-in]').value || hi.max;
      paintPrice(pr);
    }
    function paintPrice(pr) {
      var lo = pr.querySelector('[data-fx-lo]'), hi = pr.querySelector('[data-fx-hi]'), max = +lo.max || 1;
      pr.style.setProperty('--lo', (+lo.value / max * 100) + '%'); pr.style.setProperty('--hi', (+hi.value / max * 100) + '%');
    }
    function initPrice() {
      var pr = form.querySelector('[data-fx-price]'); if (!pr) return;
      var lo = pr.querySelector('[data-fx-lo]'), hi = pr.querySelector('[data-fx-hi]'), loIn = pr.querySelector('[data-fx-lo-in]'), hiIn = pr.querySelector('[data-fx-hi-in]');
      function onInput(e) {
        if (+lo.value > +hi.value - 1) { if (e.target === lo) lo.value = +hi.value - 1; else hi.value = +lo.value + 1; }
        loIn.value = +lo.value === 0 ? '' : lo.value; hiIn.value = +hi.value >= +hi.max ? '' : hi.value;
        paintPrice(pr);
      }
      lo.addEventListener('input', onInput); hi.addEventListener('input', onInput);
    }
    initPrice();
    if (window.innerWidth >= 1000) document.getElementById('panel-filters').removeAttribute('aria-hidden');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
